import type { ReactElement } from 'react';

import { YStack } from 'tamagui';

import { BodyL, Icon } from '@south-street-app/atoms';
import { useSetupNetworkConnectionChange } from '@south-street-app/hooks';
import { ScreenWrapper } from '@south-street-app/molecules';

const NoConnectionProvider = ({
  children,
}: {
  children: ReactElement | Iterable<ReactElement>;
}) => {
  const hasNetworkConnection = useSetupNetworkConnectionChange();

  if (hasNetworkConnection) {
    return <>{children}</>;
  }

  return (
    <ScreenWrapper>
      <YStack
        justifyContent={'space-between'}
        alignItems={'center'}
        flex={1}
        space={'$2'}
        paddingHorizontal={'$8'}
        backgroundColor={'$white'}
      >
        <YStack
          alignItems={'center'}
          space={'$4'}
          paddingTop={'$15'}
          paddingHorizontal={'$8'}
        >
          <YStack
            borderRadius={'$xl'}
            padding={'$3.5'}
            backgroundColor={'$mono200'}
          >
            <Icon size={'$6'} iconName={'noConnectionIcon'} color={'$black'} />
          </YStack>
          <BodyL textAlign={'center'}>
            {'No connection. Please check your internet.'}
          </BodyL>
        </YStack>
      </YStack>
    </ScreenWrapper>
  );
};

export { NoConnectionProvider };
